import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=f0700db0&scoped=true"
import script from "./DeleteButton.ts?vue&type=script&lang=ts&external"
export * from "./DeleteButton.ts?vue&type=script&lang=ts&external"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=f0700db0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0700db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0700db0')) {
      api.createRecord('f0700db0', component.options)
    } else {
      api.reload('f0700db0', component.options)
    }
    module.hot.accept("./DeleteButton.vue?vue&type=template&id=f0700db0&scoped=true", function () {
      api.rerender('f0700db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/DocumentsTab/TableFiles/DeleteButton/DeleteButton.vue"
export default component.exports